<template>
    <div class="mppt" :class="{ 'mppt--active' : active }" @click="$emit('activated')">
        <img class="mppt-image" :src="background">

        <div v-if="panel" class="mppt-panel">
            <p class="small semi">{{ panel.model }}</p>
            <p v-if="panelsPerInverter" class="mppt-voltage small semi text--grey-light">{{ panelsPerInverter }} {{ 'panel' | pluralise(panelsPerInverter) }} per inverter</p>
        </div>

        <div v-if="inverterQty" class="mppt-inverters small semi">
            <span class="mppt-inverter-qty">{{ inverterQty }}</span>
            <span class="mppt-inverter-text">inverters</span>
        </div>

        <!-- Tick icon -->
        <div class="mppt-status" :class="{ 'mppt-status--complete': valid }">
            <svg viewBox="0 0 32 32">
                <path v-if="panel" d="M28.998 8.531l-2.134-2.134c-0.394-0.393-1.030-0.393-1.423 0l-12.795 12.795-6.086-6.13c-0.393-0.393-1.029-0.393-1.423 0l-2.134 2.134c-0.393 0.394-0.393 1.030 0 1.423l8.924 8.984c0.393 0.393 1.030 0.393 1.423 0l15.648-15.649c0.393-0.392 0.393-1.030 0-1.423z" />
                <path v-else d="M19.587 16.001l6.096 6.096c0.396 0.396 0.396 1.039 0 1.435l-2.151 2.151c-0.396 0.396-1.038 0.396-1.435 0l-6.097-6.096-6.097 6.096c-0.396 0.396-1.038 0.396-1.434 0l-2.152-2.151c-0.396-0.396-0.396-1.038 0-1.435l6.097-6.096-6.097-6.097c-0.396-0.396-0.396-1.039 0-1.435l2.153-2.151c0.396-0.396 1.038-0.396 1.434 0l6.096 6.097 6.097-6.097c0.396-0.396 1.038-0.396 1.435 0l2.151 2.152c0.396 0.396 0.396 1.038 0 1.435l-6.096 6.096z" />
            </svg>
        </div>
    </div>
</template>

<script>
import pluralize from 'pluralize';

export default {
    filters: {
        pluralise(word, qty) {
            return pluralize(word, qty);
        }
    },

    props: {
        id: {
            type: [Number, String],
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        panel: {
            type: Object,
            default: null
        },
        inverterQty: {
            type: [Number, String],
            default: 1
        },
        panelsPerInverter: {
            type: [Number, String],
            default: 1
        },
        active: {
            type: Boolean,
            required: true
        },
        valid: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        background() {
            const active = this.active ? 'orange' : 'grey';
            return `/dist/images/job/mppt-micro-${active}.svg`;
        },
    }
};
</script>

<style lang="scss" scoped>
    .mppt {
        position: absolute;
    }

    .mppt-status {
        position: absolute;
        top: 6px;
        left: 90px;
        width: 44px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #DDDDDD;
        border-radius: 100%;
        border: 2px solid white;

        svg {
            width: 50%;
            fill: white;
        }
    }

        .mppt-status--complete {
            background-color: #EF6E0B;
        }

    .mppt-panel {
        position: absolute;
        top: 69px;
        left: 150px;
        white-space: nowrap;

        @media screen and (max-width: 799px) {
            width: 120px;
            white-space: normal;
        }
    }

    .mppt-inverters {
        display: flex;
        align-items: center;
        position: absolute;
        top: 10px;
        left: 310px;

        @media screen and (max-width: 799px) {
            left: 250px;
        }
    }

    .mppt-inverter-qty {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        margin-right: 1em;
        background-color: #414042;
        color: #FFF;
        border-radius: 100%;
    }

    .mppt-inverter-text {
        @media screen and (max-width: 799px) {
            display: none;
        }
    }
</style>
